import type { RouteRecordRaw } from 'vue-router'

const authRoutes: RouteRecordRaw = {
  path: '/auth',
  name: 'auth',
  meta: { layout: 'AuthLayout', requiresAuth: false, title: 'common.titles.auth' },
  redirect: '/auth/sign-in',
  children: [
    {
      path: 'sign-in',
      name: 'sign-in',
      component: () => import('@/pages/auth/login/LoginPage.vue'),
      meta: { title: 'common.titles.sign_in' },
    },
    {
      path: 'reset-password',
      name: 'reset-password',
      component: () => import('@/pages/auth/reset-password/ResetPasswordPage.vue'),
      meta: { title: 'common.titles.reset_password' },
    },
    {
      path: 'change-password/:token?',
      alias: [
        '/reset-password/:token?',
        '/api/reset-password/:token?',
        '/one/api/reset-password/:token?',
      ],
      name: 'change-password',
      component: () => import('@/pages/auth/change-password/ChangePasswordPage.vue'),
      meta: { title: 'common.titles.change_password' },
    },
  ],
}

export { authRoutes }
